import { createFileRoute } from "@tanstack/react-router";

import { BrandingColorConfig } from "@/features/onboarding/components/branding-color-config";
import { useCurrentTenant } from "@/features/tenant/api/use-current-tenant";

export const Route = createFileRoute("/_authed/onboarding/branding")({
  component: OnboardingBrandingPage,
});

/** Port of onboarding/2-LegalAssets.vue — branding assets (partial stub). */
function OnboardingBrandingPage() {
  const { data: tenant } = useCurrentTenant();

  if (!tenant) {
    return null;
  }

  return (
    <div className="pb-16">
      <BrandingColorConfig tenant={tenant} />
    </div>
  );
}
